import { createSelector } from '@reduxjs/toolkit';
import { getState } from '@yme/selectors/common';
export const getDestinationsState = createSelector(getState, (state) => state.destinations);
export const getRelatedUnits = createSelector(getDestinationsState, (state) => state.experienceDetailsPage.relatedUnits ?? []);
export const getRelatedExperiences = createSelector(getDestinationsState, (state) => state.experienceDetailsPage.data?.relatedExperiences ?? []);
